<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form id="FAQCat-form">
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input
              class="inputx"
              v-model="model.name"
              name="catName"
              :label="$t('Name')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('catName')">{{
              errors.first("catName")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input
              class="inputx"
              v-model="model.priority"
              name="catPriority"
              v-validate="{ regex: '^([0-9]+)$' }"
              :label="$t('Priority')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('catPriority')"
              >{{ errors.first("catPriority") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-4 justify-content-md-center">
          <div class="vx-col sm:w-1/4 w-full">
            <div class="uploader-box">
              <my-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="showUploader"
                :width="40"
                :height="40"
                langType="fa"
                :noCircle="true"
                img-format="jpg"
              ></my-upload>
              <img :src="model.iconImage" v-if="model.iconImage" />
              <img
                :src="URLS_CONSTANTS.assets + 'FaqCategory/' + model.iconUrl"
                v-if="model.iconUrl"
              />
              <button
                v-if="model.iconUrl"
                @click.prevent="removeIconImg"
                class="removeImg"
              >
                <feather-icon icon="XIcon" />
              </button>
            </div>
            <a class="uploadImg img-box" @click.prevent="toggleShow">
              <i class="material-icons notranslate"> cloud_upload </i>
              {{ $t("UploadIcon") }}
            </a>
          </div>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>
<style lang="scss">
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}

#FAQCat-form .uploader-box > img {
  top: calc(50% + 15px);
}
</style>

<script>
import { URLS_CONSTANTS } from "../../../../../config";
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import myUpload from "vue-image-crop-upload";

const dict = {
  custom: {
    catName: {
      required: "لطفا نام دسته‌بندی را وارد نمایید.",
    },
    catPriority: {
      regex: "تنها مجاز به وارد کردن مقادیر عددی می‌باشید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Content_management_FAQcategory_ModifyPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      showUploader: false,
      popupTitle: "",
      disabled: false,
      URLS_CONSTANTS: URLS_CONSTANTS,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createFAQcategory: "FAQcategory/create",
      updateFAQcategory: "FAQcategory/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (this.model.id != null) {
            this.updateFAQcategory(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createFAQcategory(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        }
      });
    },
    cropSuccess(imgDataUrl) {
      this.model.iconImage = imgDataUrl;
    },
    toggleShow() {
      this.showUploader = !this.showUploader;
    },
    removeIconImg() {
      this.model.iconImage = "";
      this.model.iconUrl = "";
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.id) {
          this.popupTitle = "EditFAQCategory";
        } else {
          this.popupTitle = "CreateNewFAQCategory";
        }
      }
      this.$validator.reset();
    },
  },
  components: {
    "v-select": vSelect,
    "my-upload": myUpload,
  },
};
</script>
